<template>
  <div class="drawer-overlay" :class="{ 'visible': visible }" @click.self="close">
    <transition name="slide-left">
      <div v-if="visible" class="drawer-content">
        
        <div class="drawer-header">
            <h2 class="drawer-title">Редактировать хэштеги</h2>
            <button class="close-button" @click="close">&#10005;</button>
        </div>

        <div class="drawer-body">
          <HashtagsForProfile
            :initialHashtags="initialHashtags"
            @save-hashtags="closeAfterSave"
          />
        </div>

        <div class="drawer-footer">
          <button class="save-btn" @click="saveFromFooter">Сохранить</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>

import { defineProps, defineEmits } from "vue";
import HashtagsForProfile from '../HashtagsForProfile.vue';

const props = defineProps({
  visible: Boolean,
  initialHashtags: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(["close"]);

const close = () => {
  emit("close");
};

const saveFromFooter = () => {
  document.dispatchEvent(new Event("save-hashtags"));
};

</script>

<style scoped>

.drawer-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 9999;
  pointer-events: none;
  transition: background-color 0.3s ease;
}

.drawer-overlay.visible {
  background-color: rgba(0, 0, 0, 0.4);
  pointer-events: auto;
}

.drawer-content {
  position: absolute;
  top: 0;
  height: 100%;
  width: 900px;
  background-color: white;
  padding: 24px;
  display: flex;
  flex-direction: column;
  left: 0;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
}

.drawer-header {
  display: flex;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  position: relative;
}
.drawer-title {
  font-family: "Eastman-Bold";
  font-size: 16px;
  flex: 1;
}
.close-button {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: var(--text-primary);
}
[data-theme="dark"] .drawer-header {
  border-bottom: 1px solid #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #444;
}

.drawer-body {
  padding: 40px 30px;
  flex: 1;
  overflow-y: auto;
}

.hashtags-list {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.hashtag-item {
  background-color: #f0f0f0;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-family: "Eastman-Regular", sans-serif;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.3s ease;
}

.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(-100%);
}

.drawer-footer {
  padding: 16px 30px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}

.save-btn {
  background-color: #2887F7;
  color: white;
  padding: 10px 24px;
  margin-bottom: 20px;
  border: none;
  border-radius: 24px;
  font-family: "Eastman-Medium", sans-serif;
  font-size: 14px;
  cursor: pointer;
}

/* Темная тема */
[data-theme="dark"] .drawer-overlay.visible {
  background-color: rgba(0, 0, 0, 0.6);
}

[data-theme="dark"] .drawer-content {
  background-color: #2a2a2a;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.8);
}

[data-theme="dark"] .drawer-header {
  border-bottom: 1px solid #444;
  color: #eee;
}

[data-theme="dark"] .drawer-title {
  color: #eee;
}

[data-theme="dark"] .close-button {
  color: #eee;
}

[data-theme="dark"] .drawer-body {
  padding: 40px 30px;
  color: #ddd;
  background-color: #2a2a2a;
}

[data-theme="dark"] .hashtags-list {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

[data-theme="dark"] .hashtag-item {
  background-color: #444;
  color: #eee;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-family: "Eastman-Regular", sans-serif;
}

[data-theme="dark"] .drawer-footer {
  border-top: 1px solid #444;
}

[data-theme="dark"] .save-btn {
  background-color: #3a7de0;
  color: white;
  transition: background-color 0.3s ease;
}

[data-theme="dark"] .save-btn:hover {
  background-color: #2865c6;
}

</style>